<template>
    <div>
        <div class="user-info-section">
            <div class="user-avatar">
                <img
                    v-if="userInfo.headimage || userInfo.wxheadimageid"
                    :src="$util.fileDownloadPath(userInfo.headimage || userInfo.wxheadimageid)"
                    alt="头像"
                />
                <img
                    v-else-if="userInfo.sex === '1'"
                    :src="require('@/assets/img/male.png')"
                    alt="男性头像"
                />
                <img v-else :src="require('@/assets/img/female.png')" alt="女性头像" />
                <el-upload
                    :action="$util.fileUploadPath('/sale-mid-ump/file/cmsUpload')"
                    :data="$util.fileUploadParam('10')"
                    :headers="$util.fileUploadHeader()"
                    :before-upload="uploadBefore"
                    :on-error="uploadError"
                    :on-success="uploadSuccess"
                    :show-file-list="false"
                >
                    <span class="img-btn">编辑</span>
                </el-upload>
            </div>
            <div class="user-details">
                <div class="user-info-left-col">
                    <div class="welcome-text">
                        <span class="welcome-label">欢迎您，</span>
                        <span class="user-name">{{ maskName(userInfo.custname) }}</span>
                    </div>
                    <span class="risk-level">
                        风险等级：{{ getRiskLevelText(userInfo.risklevel) }}
                    </span>
                    <span v-if="lastLoginTime" class="risk-level">
                        上次登录时间：{{ lastLoginTime }}
                    </span>
                </div>
                <div class="user-info-right-col">
                    <div class="reserve-info">
                        <span class="label">预留信息：</span>
                        <span
                            class="value"
                            :class="{ 'not-set': !userInfo.remark }"
                            v-on:click="toModifyRemark"
                        >
                            {{ userInfo.remark || "暂未设置" }}
                        </span>
                    </div>
                    <div class="complete-info">
                        <span class="label">完善信息</span>
                        <div class="progress-bar">
                            <div
                                class="progress-fill"
                                :style="{ width: completePercent + '%' }"
                            ></div>
                        </div>
                        <span class="percent">{{ completePercent }}%</span>
                    </div>
                    <div v-if="lastLoginIp" class="reserve-info">
                        <span class="label">上次登录地址：</span>
                        <span class="value">{{ lastLoginIp }}</span>
                    </div>
                </div>
            </div>
        </div>
        <remark-dialog
            :visible="remarkShow"
            :current-remark="userInfo.remark"
            v-on:close="remarkShow = false"
            v-on:success="handleRemarkSuccess"
        />
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import RemarkDialog from "@/components/acctInfo/remarkDialog.vue";

export default {
    name: "UserInfo",
    components: {
        RemarkDialog
    },
    mixins: [mixin],
    data() {
        return {
            userInfo: {},
            remarkShow: false
        };
    },
    computed: {
        lastLoginTime() {
            const value = this.userInfo.lastlogintime;
            if (this.$util.isEmpty(value)) return "";
            return String(value).replace(
                /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/,
                "$1-$2-$3 $4:$5:$6"
            );
        },
        lastLoginIp() {
            return this.userInfo.lastloginip || "";
        },

        // 信息完善百分比
        completePercent() {
            let percent = 0;
            const info = this.userInfo;

            // 基础信息项
            const checks = [
                info.custname, // 姓名
                info.certificateno, // 证件号码
                info.mobile, // 手机号
                info.email, // 邮箱
                info.headimage, // 头像
                info.remark // 预留信息
            ];

            const completed = checks.filter((item) => item && item.trim()).length;
            percent = Math.round((completed / checks.length) * 100);

            return percent > 100 ? 100 : percent;
        }
    },
    watch: {
        "$store.state.user.info"() {
            // 顶部预留信息弹窗也会更新用户缓存，首页卡片需跟随同步，避免同页展示新旧不一致。
            this.userInfo = this.$cache.getUser() || {};
        }
    },
    mounted() {
        this.userInfo = this.$cache.getUser() || {};
    },
    methods: {
        // 姓名脱敏
        maskName(name) {
            if (!name) return "";
            if (name.length <= 2) {
                return name.charAt(0) + "*";
            }
            return name.charAt(0) + "**";
        },
        // 获取风险等级文本
        getRiskLevelText(risklevel) {
            if (!risklevel) return "暂未评测";
            return this.$cache.getDict("100017", risklevel) || "暂未评测";
        },
        // 预留信息仅在当前首页弹窗处理，避免纯代销用户被带到账户安全页。
        toModifyRemark() {
            this.remarkShow = true;
        },
        handleRemarkSuccess(info) {
            this.userInfo = info;
            this.$emit("update-user-info", info);
        },
        // 头像上传前校验
        uploadBefore(file) {
            let maxSize = "3";
            if (file.size > 1024 * 1024 * maxSize) {
                this.headimage = "";
                this.$message.warning("上传文件大小超过限制大小" + maxSize + "M，不能上传");
                return false;
            }
        },
        // 头像上传失败
        uploadError(err, file, fileList) {
            this.$message.warning(err);
        },
        // 头像上传成功
        async uploadSuccess(response, file, fileList) {
            const userApi = await import("@/api/user");
            const res = await userApi.default.modifyAcctExt({
                headimage: response.data.id
            });
            if (res.code == "0") {
                const info = this.$cache.getUser();
                info.headimage = response.data.id;
                this.$cache.setHeadImage(response.data.id);
                this.$store.dispatch("setInfo", info);
                this.$emit("update-user-info", info);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.user-info-section {
    display: flex;
    align-items: center;
    gap: 33px;
    padding: 33px 50px 34px 50px;
    width: 1150px;
    min-height: 120px;
    background: var(--linear-gradient-bg);
    border-radius: 4px;
    border: 1px solid;
    border-image: var(--linear-gradient-border);
    margin: 35px auto 16px;
    box-sizing: border-box;

    .user-avatar {
        position: relative;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        overflow: hidden;
        background: #f5f5f5;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .img-btn {
            position: absolute;
            bottom: 0px;
            line-height: 24px;
            z-index: 100;
            width: 100%;
            left: 0;
            cursor: pointer;
            text-align: center;
            color: #ffffff;
            font-size: 12px;
            background-color: rgba(0, 0, 0, 0.3);
            display: none;
        }

        &:hover .img-btn {
            display: block;
        }

        .el-upload {
            position: absolute;
            bottom: 0px;
            right: 0px;
            z-index: 101;
            opacity: 0;
        }
    }

    .user-details {
        width: 520px;
        display: flex;
        justify-content: space-between;

        .user-info-left-col {
            display: flex;
            flex-direction: column;
            gap: 16px;

            .welcome-text {
                font-size: 12px;
                color: #333;
                line-height: 16px;

                .user-name {
                    font-size: 16px;
                }
            }

            .risk-level {
                font-size: 12px;
                color: #999;
                line-height: 16px;
            }
        }

        .user-info-right-col {
            display: flex;
            flex-direction: column;
            gap: 16px;

            .reserve-info {
                font-size: 12px;
                display: flex;
                align-items: center;
                gap: 4px;
                line-height: 16px;

                .label {
                    color: #999;
                }

                .value {
                    color: var(--color-primary);
                    cursor: pointer;

                    &:hover {
                        opacity: 0.8;
                    }

                    &.not-set {
                        color: #999;
                    }
                }
            }

            .complete-info {
                display: flex;
                align-items: center;
                gap: 8px;
                font-size: 12px;
                line-height: 16px;

                .label {
                    color: #999;
                    white-space: nowrap;
                }

                .progress-bar {
                    width: 120px;
                    height: 8px;
                    background: #e8e8e8;
                    border-radius: 4px;
                    overflow: hidden;

                    .progress-fill {
                        height: 100%;
                        background: linear-gradient(90deg, #ff6b35 0%, #ff8c5a 100%);
                        border-radius: 4px;
                        transition: width 0.3s ease;
                    }
                }

                .percent {
                    color: #333;
                    font-weight: 400;
                }
            }
        }
    }
}
</style>
